import {Button} from "antd";
import styled from "styled-components";

export const ActionButton = styled(Button)`
    padding: 0px 8px;
    font-size: 12px;
    @media (max-width: 768px) {
        width: 100%;
    }
`;
